(function(){
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root){
    root = root || document;

    /* revelation au scroll - test geometrique, fiable meme en scroll rapide */
    var pend = [].slice.call(root.querySelectorAll('.nv-rv:not(.in),.nv-rvi:not(.in)'));
    window.__nvPend = (window.__nvPend || []).concat(pend);
    var counters = [].slice.call(root.querySelectorAll('[data-nv-count]'));

    function sweep(){
      var list = window.__nvPend || [], lim = window.innerHeight * 0.92, keep = [];
      for (var i=0;i<list.length;i++){
        var el = list[i];
        if (el.getBoundingClientRect().top < lim) el.classList.add('in'); else keep.push(el);
      }
      window.__nvPend = keep;
      for (var j=counters.length-1;j>=0;j--){
        var c = counters[j];
        if (c.getBoundingClientRect().top < window.innerHeight * 0.85){ run(c); counters.splice(j,1); }
      }
    }
    function run(el){
      var end = parseInt(el.getAttribute('data-nv-count'),10) || 0;
      if (RM){ el.textContent = end; return; }
      var t0 = null, D = 1400;
      requestAnimationFrame(function step(t){
        if(!t0) t0 = t;
        var p = Math.min((t-t0)/D, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1-p,3)));
        if (p < 1) requestAnimationFrame(step);
      });
    }
    window.__nvSweep = sweep;
    sweep();
    setTimeout(sweep, 350); setTimeout(sweep, 1400);

    root.querySelectorAll('[data-nv-arrow]').forEach(function(b){
      b.addEventListener('click', function(){
        var r = document.getElementById(b.getAttribute('data-nv-arrow'));
        if(!r) return;
        r.scrollBy({left: parseInt(b.getAttribute('data-nv-dir'),10) * Math.min(r.clientWidth*0.8, 640),
                    behavior: RM ? 'auto' : 'smooth'});
      });
    });
    root.querySelectorAll('.nv-rail').forEach(function(r){
      if (r.__nvBound) return; r.__nvBound = true;
      var down=false, sx=0, sl=0;
      r.addEventListener('pointerdown', function(e){ down=true; sx=e.clientX; sl=r.scrollLeft; r.classList.add('drag'); });
      window.addEventListener('pointerup', function(){ down=false; r.classList.remove('drag'); });
      r.addEventListener('pointermove', function(e){ if(down) r.scrollLeft = sl - (e.clientX - sx); });
      function upd(){
        var btns = document.querySelectorAll('[data-nv-arrow="'+r.id+'"]');
        if(btns[0]) btns[0].disabled = r.scrollLeft < 6;
        if(btns[1]) btns[1].disabled = r.scrollLeft > r.scrollWidth - r.clientWidth - 6;
      }
      r.addEventListener('scroll', upd, {passive:true}); upd();
    });
  }

  var tick = false;
  function para(){
    if (RM) return;
    document.querySelectorAll('[data-nv-para]').forEach(function(m){
      var host = m.parentElement, r = host.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0){
        var amt = parseFloat(m.getAttribute('data-nv-para')) || 0.2;
        m.style.transform = 'translate3d(0,' + ((r.top - window.innerHeight/2) * -amt) + 'px,0)';
      }
    });
  }
  window.addEventListener('scroll', function(){
    if(!tick){ requestAnimationFrame(function(){ para(); if(window.__nvSweep) window.__nvSweep(); tick=false; }); tick=true; }
  }, {passive:true});
  window.addEventListener('resize', function(){ para(); if(window.__nvSweep) window.__nvSweep(); }, {passive:true});
  window.addEventListener('load', function(){ para(); if(window.__nvSweep) window.__nvSweep(); });

  document.addEventListener('DOMContentLoaded', function(){ init(document); para(); });
  if (document.readyState !== 'loading'){ init(document); para(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); para(); });
})();
